import React from "react";
import { useNavigate } from "react-router-dom";

const getInitials = (name = "") => {
  const words = name.trim().split(" ");
  return words.map((w) => w[0]).slice(0, 2).join("").toUpperCase();
};

const EmployeeProfile = () => {
  const navigate = useNavigate();
  const employeeDetails = JSON.parse(localStorage.getItem("employeeDetails"));

  if (!employeeDetails) {
    return (
      <p className="text-center text-gray-500 text-lg mt-10">
        No employee details found.
      </p>
    );
  }

  const { name, email, phone, emp_id, designation, department, reporting_manager,working_city } = employeeDetails;

  return (
    <div className="px-4 py-8 flex justify-center">
      <div className="w-full max-w-5xl bg-white rounded-xl shadow-lg p-8">
        {/* Profile Header Section */}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold">
            {getInitials(name)}
          </div>
          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">{name}</h2>
            <p className="text-gray-500 text-sm sm:text-base">{email}</p>
          </div>
        </div>

        {/* Details Section */}
        <div className="divide-y divide-gray-300 text-sm sm:text-base">
          <div className="py-4 grid grid-cols-2 sm:grid-cols-4">
            <div className="text-gray-500 font-medium">Employee ID</div>
            <div className="text-gray-900 col-span-3">{emp_id}</div>
          </div>

          <div className="py-4 grid grid-cols-2 sm:grid-cols-4">
            <div className="text-gray-500 font-medium">Name</div>
            <div className="text-gray-900 col-span-3">{name}</div>
          </div>

          <div className="py-4 grid grid-cols-2 sm:grid-cols-4">
            <div className="text-gray-500 font-medium">Email</div>
            <div className="text-gray-900 col-span-3">{email}</div>
          </div>

          <div className="py-4 grid grid-cols-2 sm:grid-cols-4">
            <div className="text-gray-500 font-medium">Mobile</div>
            <div className="text-gray-900 col-span-3">{phone}</div>
          </div>

          <div className="py-4 grid grid-cols-2 sm:grid-cols-4">
            <div className="text-gray-500 font-medium">Department</div>
            <div className="text-gray-900 col-span-3">{department}</div>
          </div>

          <div className="py-4 grid grid-cols-2 sm:grid-cols-4">
            <div className="text-gray-500 font-medium">Designation</div>
            <div className="text-gray-900 col-span-3">{designation}</div>
          </div>

          <div className="py-4 grid grid-cols-2 sm:grid-cols-4">
            <div className="text-gray-500 font-medium">Working City</div>
            <div className="text-gray-900 col-span-3">{working_city}</div>
          </div>

          <div className="py-4 grid grid-cols-2 sm:grid-cols-4">
            <div className="text-gray-500 font-medium">Reporting Manager</div>
            <div className="text-gray-900 col-span-3">{reporting_manager}</div>
          </div>

        </div>

        {/* Update Password Link */}
        <div className="mt-6 text-right">
          <span
            onClick={() => navigate("/sidebar/update-password")}
            className="text-green-600 hover:underline hover:text-green-800 decoration-green-600 cursor-pointer font-medium"
          >
            Update Password
          </span>

        </div>
      </div>
    </div>
  );
};

export default EmployeeProfile;
